import classNames from 'classnames';
import React from 'react';

interface RCSiteWrapperProps {
  /** Any/all content that should be wrapped */
  children: React.ReactNode;
  width?: 'default' | 'narrow';
}

export function RCSiteWrapper({
  children,
  width = 'default',
}: RCSiteWrapperProps) {
  return (
    <div className={classNames(
      'rc-site-wrapper',
      {
        'rc-site-wrapper--narrow': width === 'narrow',
      },
    )}>
      {children}
    </div>
  );
}
